import { createReducer } from '@reduxjs/toolkit';
import { v4 as uuid } from 'uuid';
import { annotationActions } from './actions';
import { AnnotationState } from './types';

const initialState: AnnotationState = {
  localCommands: [],
  isQueueProcessing: false,
};

export const annotationReducer = createReducer(initialState, builder =>
  builder
    .addCase(annotationActions.annotationQueueCommand, (state, { payload }) => {
      state.localCommands.push({
        ...payload.command,
        retryCount: 0,
        commandId: uuid(),
        issuedAt: Date.now(),
      });
    })
    .addCase(annotationActions.annotationQueueProcessStart, state => {
      state.isQueueProcessing = true;
    })
    .addCase(annotationActions.annotationQueueProcessComplete, state => {
      state.isQueueProcessing = false;
    })
    .addCase(annotationActions.annotationSyncCommandSuccess, (state, { payload }) => {
      state.localCommands = state.localCommands.filter(i => i.commandId !== payload.commandId);
    })
    .addCase(annotationActions.annotationSyncCommandFailure, (state, { payload }) => {
      const cmd = state.localCommands.find(i => i.commandId === payload.commandId);
      if (!cmd) {
        console.warn(
          'Got a annotationSyncCommandFailure action, but no command exists matching the id:',
          payload.commandId,
        );
        return;
      }

      if (cmd.retryCount >= 2) {
        console.warn('Got a annotationSyncCommandFailure action for the same annotation 3 times, not trying again');
        state.localCommands = state.localCommands.filter(i => i.commandId !== payload.commandId);
      } else {
        cmd.retryCount += 1;
      }
    })
    .addCase(annotationActions.annotationClaimCommand, (state, { payload }) => {
      for (const cmd of state.localCommands) {
        if (cmd.type === 'create' && cmd.parentClaimKey === payload.parentClaimKey) {
          cmd.parentId = payload.parentId;
        }
      }
    })
    .addDefaultCase(state => state),
);
